<template>
  <div>
    <div class="bj">
      <el-row>
        <el-col :span="6">
          <div class="left">
            <div class="left-top">
              <div class="top"></div>
              <div class="bottom">
                大棚名称 : <span class="xinxi">XXX大棚</span>
              </div>
              <div class="bottom">
                大棚面积 : <span class="xinxi">xxxm</span>
              </div>
              <div class="bottom">
                种植作物 : <span class="xinxi">番茄</span>
              </div>
              <div class="bottom">
                种植日期 : <span class="xinxi">2022-06-06</span>
              </div>
              <div class="bottom">
                生长阶段 : <span class="xinxi">幼苗期</span>
              </div>
            </div>
            <div class="left-bottom">
              <div class="top">

              </div>
              <div class="bottom" v-for="item in modelList" :key="item.id">
                <img :src="item.cropImage" alt="">
                <div class="title">
                  <img style="cursor: pointer;" src="~@/assets/形状 2.png" alt="">
                  {{ item.modelStageName }}
                  <img style="cursor: pointer;" src="~@/assets/形状 2(1).png" alt="">
                </div>
                <div class="cropName">
                  {{ item.cropName }}
                </div>
              </div>

            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="main">
            <div class="top" style="height: 80vh;">
            </div>
            <div class="bottom" style="display: flex;justify-content: space-around;">
              <div v-for="(item, index) in numericalList " :key="index">
                <img :src="item[2]" alt="">
                <div style="display: flex;justify-content: center;color: #ffffff;font-size: 14px;">{{ item[0] }}</div>
                <div
                  style="display: flex;justify-content: center;color: #ffffff;font-size: 14px;background-color: #0b4346;border-radius: 15px;margin-top: 0.5rem;border: 1px solid #1aa47d;">
                  {{ item[1]
                  }}</div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="right">
            <div class="right-top">
              <div class="top"></div>
              <div style="display: flex;">

                <div class="bottom">

                </div>
                <div class="bottom" style="margin-left: 0.5rem;">

                </div>
              </div>
            </div>
            <div class="right-main">
              <div class="top"></div>
              <div class="bottom">

              </div>
            </div>
            <div class="right-bottom">
              <div class="left">农事记录</div>
              <div class="right">报警记录</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      modelList: [],
      numericalList: [],
    }
  },
  created() {
    this.getHisGrowthModelList()
    this.getGrowthModelDecisionList()
  },
  methods: {
    getStatus() {
      this.numericalList = this.modelList[0].currentPhysicalEnvironment.split(',')
      let list = []
      this.numericalList.map(item => {
        list.push(item.split(':'))
      })
      list.map(item => {
        if (item[0] == '光照强度') {
          let a = require('@/assets/guangzhao.png')
          item.push(a)
        } else if (item[0] == '空气湿度') {
          let a = require('@/assets/guangzhao(1).png')
          item.push(a)
        } else if (item[0] == '空气温度') {
          let a = require('@/assets/guangzhao(2).png')
          item.push(a)
        } else if (item[0] == 'co2') {
          let a = require('@/assets/guangzhao(3).png')
          item.push(a)
        } else if (item[0] == '土壤湿度') {
          let a = require('@/assets/guangzhao(4).png')
          item.push(a)
        } else if (item[0] == '土壤温度') {
          let a = require('@/assets/guangzhao(5).png')
          item.push(a)
        } else if (item[0] == '土壤EC值') {
          let a = require('@/assets/guangzhao(6).png')
          item.push(a)
        } else if (item[0] == '土壤PH') {
          let a = require('@/assets/guangzhao(7).png')
          item.push(a)
        } else if (item[0] == '用电量') {
          let a = require('@/assets/guangzhao(8).png')
          item.push(a)
        } else if (item[0] == '用水量') {
          let a = require('@/assets/guangzhao(9).png')
          item.push(a)
        }
      })
      this.numericalList = list
      console.log(this.numericalList);
    },
    getHisGrowthModelList() {
      let search = {
        pageNum: 1,
        pageSize: 10
      }
      this.$api.system
        .getHisGrowthModelList(search)
        .then((res) => {

        })
    },
    getGrowthModelDecisionList() {
      let search = {
        pageNum: 1,
        pageSize: 10,
        cropId: 6
      }
      this.$api.system
        .getGrowthModelDecisionList(search)
        .then((res) => {
          this.modelList = res.data
          this.getStatus()
        })
    }
  }
}

</script>
<style lang="scss" scoped>
@import "../../style/screenMonitors.scss";
</style>
